import GlasgowLogistics_Master from "./testingImages/GlasgowLogistics_Master.jpg"
import CateringWorld_Vivaro from "./testingImages/CateringWorld_Vivaro.jpg"
import DLTimber_CrafterMWB from "./testingImages/DLTimber_CrafterMWB.jpg"
import Norelo_Ranger from "./testingImages/Norelo_Ranger.jpg"
import PrintFileExample1 from "./testingPDFs/PrintFileExample1.pdf"
import PrintFileExample2 from "./testingPDFs/PrintFileExample2.pdf"


export const JOB_LIST = [
    //data for admin section
    {
        id: "0001",
        name: "Lidl",
        dates: {
            enquiryReceived: "2023-03-08",
            enquiryApproved: "--/--/----",

            designsRequested: "--/--/----",
            designsUploaded: "--/--/----",
            designChosen: "--/--/----",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Larry Lidl",
            companyName: "Lidl",
            customerEmail: "Lidl@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "Hi Cubewraps, I'm thinking about starting a delivery service so I'd like to have 6 vans wrapped with a Lidl design.",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne : {
                id: "0001",
                make: "Ford",
                model: "Transit Connect",
                licencePlate: "LIDL 001",
                comments: "All 6 of our vans will be this make and model",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },

            }
        },

        designImages: {
            designOne: "",
            designTwo: "",
            designThree: "",
            chosenDesign: "",
        },

        printFiles: [],

        adminStatus: "UNAPPROVED",
        designStatus:"NOT STARTED",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "ENQUIRY RECEIVED",
    },

    {
        id: "0002",
        name: "Aldi",
        dates: {
            enquiryReceived: "2023-02-13",
            enquiryApproved: "14/02/2023",

            designsRequested: "--/--/----",
            designsUploaded: "--/--/----",
            designChosen: "--/--/----",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Alex Aldi",
            companyName: "Aldi",
            customerEmail: "Aldi@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I want two minis and one unicycle wrapped in our brand colours",
            numberOfVehicles : "2",
        },

        vehicles: {
            vehicleOne : {
                id: "0001",
                make: "Mini",
                model: "Cooper",
                licencePlate: "ALDI 001",
                comments: "I want these to be orange",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },

            vehicleTwo : {
                id: "0002",
                make: "Unicycle",
                model: "x1000",
                licencePlate: "ALDI 002",
                comments: "This is my personal unicyle and I would like my face on it",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },
        },

        designImages: {
            designOne: "",
            designTwo: "",
            designThree: "",
            chosenDesign: "",
        },

        printFiles: [],

        adminStatus: "APPROVED",
        designStatus:"NOT STARTED",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "ENQUIRY APPROVED",
    },

    {
        id: "0003",
        name: "Sainsbury's",
        dates: {
            enquiryReceived: "2023-03-11",
            enquiryApproved: "--/--/----",

            designsRequested: "--/--/----",
            designsUploaded: "--/--/----",
            designChosen: "--/--/----",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Sam Sainsbury",
            companyName: "Sainsbury's",
            customerEmail: "Sainsbury@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I'd like 4 cars wrapped in branding",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne : {
                id: "0001",
                make: "Fiat",
                model: "500",
                licencePlate: "SAINS 001",
                comments: "Make this mostly orange",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },
        },

        designImages: {
            designOne: "",
            designTwo: "",
            designThree: "",
            chosenDesign: "",
        },

        printFiles: [],

        adminStatus: "UNAPPROVED",
        designStatus:"NOT STARTED",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "ENQUIRY RECEIVED",
    },

    // data for design section
    {
        id: "0004",
        name: "Waitrose",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "--/--/----",
            designChosen: "--/--/----",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Wendy Waitrose",
            companyName: "Waitrose",
            customerEmail: "Waitrose@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I want a car wrapped in our branding but i'm not sure which one yet",
            numberOfVehicles : "0",
        },

        vehicles: {
        },

        designImages: {
            designOne: "",
            designTwo: "",
            designThree: "",
            chosenDesign: "",
        },

        printFiles: [],

        adminStatus: "APPROVED",
        designStatus:"NO DESIGNS",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "NO DESIGNS",
    },

    {
        id: "0005",
        name: "Tesco",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "--/--/----",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Tabitha Tesco",
            companyName: "Tesco",
            customerEmail: "Tesco@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I would like to enquire about getting a smallish fleet of our lorries wrapped in tesco branding," +
                "I am still currently deciding between the type of lorries I would like wrapped so I haven't provided any vehicle information",
            numberOfVehicles : "0",
        },

        vehicles: {
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: "",
        },

        printFiles: [],

        adminStatus: "APPROVED",
        designStatus:"DESIGNS UPLOADED",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "DESIGNS UPLOADED",
    },

    {
        id: "0006",
        name: "Morrisons",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "26/02/2023",
            designsCompleted: "--/--/----",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Mark Morrison",
            companyName: "Morrisons",
            customerEmail: "Morrisons@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I would like some Landrovers covered in morrisons branding",
            numberOfVehicles : "1",
        },

        vehicleOne : {
            id: "0001",
            make: "Landrover",
            model: "Discovery",
            licencePlate: "MORR 001",
            comments: "Because morrisons is obviously the bad ass of all supermarkets we are going to run an off roading advertising" +
                " campaign with branded landrovers, this means the wrapping needs to be as durable as possible",

            vehicleDates: {
                installationBooked: "--/--/----",
                vehicleArrived: "--/--/----",
                preChecklist: "--/--/----",
                vehicleWrapped: "--/--/----",
                postChecklist: "--/--/----",
            },
        },
        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [],

        adminStatus: "APPROVED",
        designStatus:"DESIGN CHOSEN",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "DESIGN CHOSEN",
    },

    {
        id: "0007",
        name: "Asda",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "26/02/2023",
            designsCompleted: "27/02/2023",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Amy Asda",
            companyName: "Asda",
            customerEmail: "Asda@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I would like some Toyota Yaris's covered in your best green vinyl",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne: {
                id: "0001",
                make: "Toyota",
                model: "Yaris",
                licencePlate: "ASDA 001",
                comments: "We at asda have decided that the best way to get people to shop with us is to run a car give away. " +
                    "Why? we hear you ask. Well we didn't have another idea that could be used for this sample data.",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [],

        adminStatus: "APPROVED",
        designStatus:"COMPLETE",
        printingStatus: "NOT STARTED",
        jobStatus: "INCOMPLETE",

        overallStatus: "PAYMENT MADE",
    },

    {
        id: "0008",
        name: "Dobbies",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "26/02/2023",
            designsCompleted: "27/02/2023",

            printFilesCompleted: "--/--/----",
            vinylsPrinted: "--/--/----",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Denise Dobbies",
            companyName: "Dobbies",
            customerEmail: "Dobbies@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I want you to make 3 Kia ceeds (get it cause it sounds like seeds) into beautiful flower cars",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne: {
                id: "0001",
                make: "Kia",
                model: "Ceed",
                licencePlate: "FLWR 001",
                comments: "This is the funniest joke the Dobbies marketing team has ever made (haha ceed)",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [{name: "KiaCeed_PrintFile.pdf", file: PrintFileExample1}],

        adminStatus: "APPROVED",
        designStatus:"COMPLETE",
        printingStatus: "INCOMPLETE",
        jobStatus: "INCOMPLETE",

        overallStatus: "PAYMENT MADE",
    },

    {
        id: "0009",
        name: "Pets at Home",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "26/02/2023",
            designsCompleted: "27/02/2023",

            printFilesCompleted: "01/03/2023",
            installationScheduled: "--/--/----",
            installationComplete: "--/--/----",
        },

        enquiry: {
            customerName: "Peter Pets",
            companyName: "Pets at Home",
            customerEmail: "Petsindahouse@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "I would like to have a mini cooper covered with pets",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne: {
                id: "0001",
                make: "Mini",
                model: "Cooper",
                licencePlate: "PETS 001",
                comments: "We would like 3 of these minis wrapped",

                vehicleDates: {
                    installationBooked: "--/--/----",
                    vehicleArrived: "--/--/----",
                    preChecklist: "--/--/----",
                    vehicleWrapped: "--/--/----",
                    postChecklist: "--/--/----",
                },
            },
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [{name: "MiniCooper_PrintFile.pdf", file: PrintFileExample1}],

        adminStatus: "APPROVED",
        designStatus:"COMPLETE",
        printingStatus: "COMPLETE",
        jobStatus: "INCOMPLETE",

        overallStatus: "VINYLS PRINTED",
    },


    {
        id: "0010",
        name: "Co-op",
        dates: {
            enquiryReceived: "2023-02-14",
            enquiryApproved: "15/02/2023",

            designsRequested: "15/02/2023",
            designsUploaded: "21/02/2023",
            designChosen: "26/02/2023",
            designsCompleted: "27/02/2023",

            printFilesCompleted: "01/03/2023",
            installationScheduled: "06/03/2023",
            installationComplete: "11/03/2023",
        },

        enquiry: {
            customerName: "Carly Coop",
            companyName: "Co-op",
            customerEmail: "coopcarly@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "We are looking into starting a Co-op delivery service and for that we need branded vehicles",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne: {
                id: "0001",
                make: "Van",
                model: "Generic",
                licencePlate: "COOP 001",
                comments: "We haven't decided on what kind of van we want wrapped yet so we will keep you updated on what we want " +
                    "ideally we would like these to contain some sort of coop branding but we'll leave that mostly up to you, " +
                    "we would like you to use our colour scheme please. We probably want about 5 or 6 of these wrapped initially with " +
                    "the possibility to place a second order for a fleet of about 30",

                vehicleDates: {
                    installationBooked: "05/03/2023",
                    vehicleArrived: "07/03/2023",
                    preChecklist: "07/03/2023",
                    vehicleWrapped: "07/03/2023",
                    postChecklist: "07/03/2023",
                },
            },
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [{name: "Co-op_PrintFile.pdf", file: PrintFileExample1}],

        adminStatus: "APPROVED",
        designStatus:"COMPLETE",
        printingStatus: "COMPLETE",
        jobStatus: "COMPLETE",

        overallStatus: "COMPLETE",
    },

    {
        id: "0011",
        name: "DFS",
        dates: {
            enquiryReceived: "2023-03-1",
            enquiryApproved: "01/03/2023",

            designsRequested: "15/03/2023",
            designsUploaded: "21/03/2023",
            designChosen: "26/03/2023",
            designsCompleted: "27/03/2023",

            printFilesCompleted: "01/04/2023",
            installationScheduled: "06/04/2023",
            installationComplete: "11/04/2023",
        },

        enquiry: {
            customerName: "Desmond Dfs",
            companyName: "DFS",
            customerEmail: "desmondfs@totallyrealemail.com",
            phoneNumber: "0000000000",
            message: "We would like to promote our branding via some mini coopers. We're not sure what we want yet but would be happy " +
                "to discuss ideas with you",
            numberOfVehicles : "1",
        },

        vehicles: {
            vehicleOne: {
                id: "0001",
                make: "Mini",
                model: "Cooper",
                licencePlate: "DFS 001",
                comments: "No Comments",

                vehicleDates: {
                    installationBooked: "05/04/2023",
                    vehicleArrived: "07/04/2023",
                    preChecklist: "07/04/2023",
                    vehicleWrapped: "07/04/2023",
                    postChecklist: "07/04/2023",
                },
            },
        },

        designImages: {
            designOne: GlasgowLogistics_Master,
            designTwo: Norelo_Ranger,
            designThree: DLTimber_CrafterMWB,
            chosenDesign: Norelo_Ranger,
        },

        printFiles: [{name: "MiniCooper_PrintFile.pdf", file: PrintFileExample1}],

        adminStatus: "APPROVED",
        designStatus:"COMPLETE",
        printingStatus: "COMPLETE",
        jobStatus: "COMPLETE",

        overallStatus: "COMPLETE",
    },

]